import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

async function post(path, body) {
  const response = await fetch(`${API_BASE}${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    throw new Error(err.error || 'No se pudo completar la importación')
  }
  return response.json()
}

export const previewContractImport = (parkId, rows) => post(`/parks/${parkId}/contracts/import/preview`, { rows })
export const runContractImport = (parkId, rows, skipInvalid) => post(`/parks/${parkId}/contracts/import`, { rows, skipInvalid })